"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignmentSummaryPreviewAttachmentSchema = exports.AssignmentBorrowingBaseReportForPreviewSchema = exports.AssignmentReceivablesPreviewAttachmentBaseSchema = exports.AssignmentBorrowingBaseReportSchema = exports.ReceivableResponseTapePreviewPayloadSchema = exports.SignaledAssignmentsSchema = exports.ReceivableResponseTapePreviewStatus = exports.ReceivableResponseTapePreviewStatusIterable = void 0;
const zod_1 = require("zod");
const CreditAgreement_1 = require("../CreditAgreement");
const Utils_1 = require("../Utils");
exports.ReceivableResponseTapePreviewStatusIterable = [
    'completed',
    'failed',
    'initiated',
    'started',
];
exports.ReceivableResponseTapePreviewStatus = {
    Completed: 'completed',
    Failed: 'failed',
    Initiated: 'initiated',
    Started: 'started',
};
exports.SignaledAssignmentsSchema = zod_1.z.record(zod_1.z.string(), zod_1.z.array(zod_1.z.string()));
exports.ReceivableResponseTapePreviewPayloadSchema = zod_1.z.object({
    masterLoanTapeIds: zod_1.z.array(zod_1.z.string()),
    signaledAssignments: exports.SignaledAssignmentsSchema,
});
exports.AssignmentBorrowingBaseReportSchema = zod_1.z.object({
    creditFacilityId: zod_1.z.string(),
    totalExposure: zod_1.z.number(),
    totalExposureByLoanProductId: zod_1.z.record(zod_1.z.string(), zod_1.z.number()),
    totalEligibilityKickoutByLoanProductId: zod_1.z.record(zod_1.z.string(), zod_1.z.number()),
    totalExposureLessEligibilityKickoutsByLoanProductId: zod_1.z.record(zod_1.z.string(), zod_1.z.number()),
    totalBorrowingBaseAmount: zod_1.z.number(),
    totalBorrowingBaseAmountByLoanProductId: zod_1.z.record(zod_1.z.string(), zod_1.z.number()),
    totalProposedAssignedReceivableCount: zod_1.z.number(),
    proposedAssignedReceivableCountByLoanProductId: zod_1.z.record(zod_1.z.string(), zod_1.z.number()),
    totalEligibleExposureLessConcentrationKickouts: zod_1.z.number(),
    effectiveReceivableAdvanceRate: zod_1.z.number(),
    effectiveReceivableAdvanceRateByLoanProductId: zod_1.z.record(zod_1.z.string(), zod_1.z.number()),
    balanceSheetExposure: zod_1.z.number(),
    concentrationLimitCalculations: zod_1.z.array(CreditAgreement_1.Config.ConcentrationLimit.Calculation.ConcentrationLimitCalculationSchema),
    eligibilityCriteriaCalculations: zod_1.z.array(CreditAgreement_1.Config.EligibilityTest.EligibilityCriteriaCalculationSchema),
});
exports.AssignmentReceivablesPreviewAttachmentBaseSchema = zod_1.z.object({
    creditFacilityId: zod_1.z.string(),
    receivableResponseTapePreviewId: zod_1.z.string(),
    reportingDate: Utils_1.ZodFullDateStrForJsonSchemaStruct,
    fileVersion: zod_1.z.number(),
});
exports.AssignmentBorrowingBaseReportForPreviewSchema = exports.AssignmentBorrowingBaseReportSchema.extend({
    totalAssignableExposureByLoanProductId: zod_1.z.record(zod_1.z.string(), zod_1.z.number()),
    balanceSheetExposureByLoanProductId: zod_1.z.record(zod_1.z.string(), zod_1.z.number()),
    balanceSheetReceivableCount: zod_1.z.number(),
    balanceSheetReceivableCountByLoanProductId: zod_1.z.record(zod_1.z.string(), zod_1.z.number()),
    eligibleExposureOnBalanceSheet: zod_1.z.number(),
    eligibleExposureOnBalanceSheetByLoanProductId: zod_1.z.record(zod_1.z.string(), zod_1.z.number()),
    newlyProposedExposure: zod_1.z.number(),
});
exports.AssignmentSummaryPreviewAttachmentSchema = exports.AssignmentReceivablesPreviewAttachmentBaseSchema.extend({
    type: zod_1.z.literal('assignmentSummaryPreview'),
    borrowingBaseReport: exports.AssignmentBorrowingBaseReportForPreviewSchema,
    countsByStatus: zod_1.z.object({
        proposedAssignedReceivables: zod_1.z.record(zod_1.z.string(), // loanProductId
        zod_1.z.record(zod_1.z.string(), zod_1.z.number())),
        leftOnBalanceSheetReceivables: zod_1.z.record(zod_1.z.string(), zod_1.z.number()),
    }),
    previewIdentifier: zod_1.z.string(),
    isInitialCondition: zod_1.z.union([zod_1.z.boolean(), zod_1.z.null(), zod_1.z.undefined()]),
});
//# sourceMappingURL=Preview.js.map